export default {
      id: "voucher-24-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "assets/iconset.svg#voucher-24",
      toString: function () {
        return this.url;
      }
    }